export const statusOptions = [
    { value: 'New', label: 'New' },
    { value: 'Planned', label: 'Planned' },
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Failed', label: 'Failed' },
    { value: 'Completed', label: 'Completed' },
  ];
  